import React, { useState } from 'react';
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import SecBTN from '../../UI/SecBTN';
import Graybg from '../../UI/Graybg';
import userService from '../../app/services/user.service';
import DataTable from './DataTable/Table';


const BulkSolutionTranslation = () => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;

  console.log(user_id)
  const [selectedFile, setSelectedFile] = useState(null);
  const [dataList,setDataList]=useState([]);

  
  
  const downloadFile = () => {
    fetch(window.location.origin + "/files/bulksolutiontranslates.xlsx").then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "bulksolutiontranslates.xlsx";
        alink.click();
      });
    });
  };
  
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  
  const HandleTranslationUpload = () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }
    
    const formData = new FormData();
    formData.append("pr_data_file", selectedFile);
    formData.append("user_id", user_id);

    
    console.log(formData);
    
    userService.bulkSolutionTranslationUpload(formData)
      .then((res) => {
        console.log("API success", res.task_list);
        setDataList(res.task_list);
        alert("File uploaded successfully!");
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to upload the file.");
      });
  };
  
  return (
    <div className="section">
      <h4>Bulk Solution Translation</h4>
      <Breadcrumb>
        <Breadcrumb.Item active>Bulk Solution Translation</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
        <Row>
          <Col lg={6} md={6} sm={12} className="mb-3">
            <h5 className="mb-3">Upload QID File</h5>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload here:</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
            <SecBTN className="sec-btn1" onClick={HandleTranslationUpload}>
              Upload
            </SecBTN>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <SecBTN className="sec-btn1" onClick={downloadFile}>
              <i className="fa fa-download"></i> Sample File
            </SecBTN>
          </Col>
        </Row>
      </Graybg>

      <DataTable
        data={dataList}
        noDataShow={true}
        updateHandler={""}
        activationHandler={""}
         />
    </div>
  );
};

export default BulkSolutionTranslation;